export default __webpack_public_path__ + "static/media/neusoft-logo.fba047b5.svg";